<span *ngIf="!isEdit">{{params.data.Seller ? params.data.Seller : params.data.SellerId }}</span>
    <input
    type="text"
    *ngIf="isEdit"
    class="input-container_input input-container_input--small"
    [(ngModel)]="params.data.Seller"
    (focusout)="focusOut()"
    >

<div>
    <i class="fal fa-edit pointer" (click)="editSellerName()"></i>
    <a *ngIf="selectedAccountType != 'walmart'"
    target="_blank"
    href="https://amazon.com/sp?seller={{ params.data.SellerId }}"
  >
    <i class="fal fa-external-link-square-alt ms-2 text-primary pointer"></i
  ></a> {{params.data.IsBb}}
  <img *ngIf="params.data.IsB2b === 'IsB2b'" class="amazon-bussiness" src="../../../assets/images/amazon+business.png">
</div>